// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/task.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TaskService } from "./task";
import type { ResolvedFormDataServiceGetByTaskIdResponse } from "./task";
import type { ResolvedFormDataServiceGetByTaskIdRequest } from "./task";
import type { TaskServiceSendReminderResponse } from "./task";
import type { TaskServiceSendReminderRequest } from "./task";
import type { TaskServiceGetSendReminderPreviewResponse } from "./task";
import type { TaskServiceGetSendReminderPreviewRequest } from "./task";
import type { TaskServiceDeleteResponse } from "./task";
import type { TaskServiceDeleteRequest } from "./task";
import type { TaskServiceListRequest } from "./task";
import type { TaskServiceUpdateRequest } from "./task";
import type { TaskServiceCreateActionResponse } from "./task";
import type { TaskServiceCreateActionRequest } from "./task";
import type { TaskServiceCreateOffboardingResponse } from "./task";
import type { TaskServiceCreateOffboardingRequest } from "./task";
import type { TaskServiceListResponse } from "./task";
import type { TaskServiceCreateManyGrantTasksRequest } from "./task";
import type { TaskServiceCreateGrantResponse } from "./task";
import type { TaskServiceCreateGrantRequest } from "./task";
import type { TaskServiceCreateRevokeResponse } from "./task";
import type { TaskServiceCreateRevokeRequest } from "./task";
import type { TaskServiceCreateRequest } from "./task";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { TaskServiceGetResponse } from "./task";
import type { TaskServiceGetRequest } from "./task";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.task.v1.TaskService
 */
export interface ITaskServiceClient {
    /**
     * Get a task by ID
     *
     * @generated from protobuf rpc: Get(c1.api.task.v1.TaskServiceGetRequest) returns (c1.api.task.v1.TaskServiceGetResponse);
     */
    get(input: TaskServiceGetRequest, options?: RpcOptions): UnaryCall<TaskServiceGetRequest, TaskServiceGetResponse>;
    /**
     * @generated from protobuf rpc: Create(c1.api.task.v1.TaskServiceCreateRequest) returns (c1.api.task.v1.TaskServiceGetResponse);
     */
    create(input: TaskServiceCreateRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateRequest, TaskServiceGetResponse>;
    /**
     * Create a revoke task
     *
     * @generated from protobuf rpc: CreateRevokeTask(c1.api.task.v1.TaskServiceCreateRevokeRequest) returns (c1.api.task.v1.TaskServiceCreateRevokeResponse);
     */
    createRevokeTask(input: TaskServiceCreateRevokeRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateRevokeRequest, TaskServiceCreateRevokeResponse>;
    /**
     * Create a grant task
     *
     * @generated from protobuf rpc: CreateGrantTask(c1.api.task.v1.TaskServiceCreateGrantRequest) returns (c1.api.task.v1.TaskServiceCreateGrantResponse);
     */
    createGrantTask(input: TaskServiceCreateGrantRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateGrantRequest, TaskServiceCreateGrantResponse>;
    /**
     * Create a grant task
     *
     * @generated from protobuf rpc: CreateManyGrantTasks(c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest) returns (c1.api.task.v1.TaskServiceListResponse);
     */
    createManyGrantTasks(input: TaskServiceCreateManyGrantTasksRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateManyGrantTasksRequest, TaskServiceListResponse>;
    /**
     * @generated from protobuf rpc: CreateOffboardingTask(c1.api.task.v1.TaskServiceCreateOffboardingRequest) returns (c1.api.task.v1.TaskServiceCreateOffboardingResponse);
     */
    createOffboardingTask(input: TaskServiceCreateOffboardingRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateOffboardingRequest, TaskServiceCreateOffboardingResponse>;
    /**
     * @generated from protobuf rpc: CreateActionTask(c1.api.task.v1.TaskServiceCreateActionRequest) returns (c1.api.task.v1.TaskServiceCreateActionResponse);
     */
    createActionTask(input: TaskServiceCreateActionRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateActionRequest, TaskServiceCreateActionResponse>;
    /**
     * TODO(pquerna): validate use case - maybe remove?
     *
     * @generated from protobuf rpc: Update(c1.api.task.v1.TaskServiceUpdateRequest) returns (c1.api.task.v1.TaskServiceGetResponse);
     */
    update(input: TaskServiceUpdateRequest, options?: RpcOptions): UnaryCall<TaskServiceUpdateRequest, TaskServiceGetResponse>;
    /**
     * @generated from protobuf rpc: List(c1.api.task.v1.TaskServiceListRequest) returns (c1.api.task.v1.TaskServiceListResponse);
     */
    list(input: TaskServiceListRequest, options?: RpcOptions): UnaryCall<TaskServiceListRequest, TaskServiceListResponse>;
    /**
     * @generated from protobuf rpc: Delete(c1.api.task.v1.TaskServiceDeleteRequest) returns (c1.api.task.v1.TaskServiceDeleteResponse);
     */
    delete(input: TaskServiceDeleteRequest, options?: RpcOptions): UnaryCall<TaskServiceDeleteRequest, TaskServiceDeleteResponse>;
    /**
     * View specific
     *
     * @generated from protobuf rpc: GetSendReminderPreview(c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest) returns (c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse);
     */
    getSendReminderPreview(input: TaskServiceGetSendReminderPreviewRequest, options?: RpcOptions): UnaryCall<TaskServiceGetSendReminderPreviewRequest, TaskServiceGetSendReminderPreviewResponse>;
    /**
     * @generated from protobuf rpc: SendReminder(c1.api.task.v1.TaskServiceSendReminderRequest) returns (c1.api.task.v1.TaskServiceSendReminderResponse);
     */
    sendReminder(input: TaskServiceSendReminderRequest, options?: RpcOptions): UnaryCall<TaskServiceSendReminderRequest, TaskServiceSendReminderResponse>;
    /**
     * Get resolved form data by task ID
     *
     * @generated from protobuf rpc: GetByTaskId(c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest) returns (c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse);
     */
    getByTaskId(input: ResolvedFormDataServiceGetByTaskIdRequest, options?: RpcOptions): UnaryCall<ResolvedFormDataServiceGetByTaskIdRequest, ResolvedFormDataServiceGetByTaskIdResponse>;
}
/**
 * @generated from protobuf service c1.api.task.v1.TaskService
 */
export class TaskServiceClient implements ITaskServiceClient, ServiceInfo {
    typeName = TaskService.typeName;
    methods = TaskService.methods;
    options = TaskService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get a task by ID
     *
     * @generated from protobuf rpc: Get(c1.api.task.v1.TaskServiceGetRequest) returns (c1.api.task.v1.TaskServiceGetResponse);
     */
    get(input: TaskServiceGetRequest, options?: RpcOptions): UnaryCall<TaskServiceGetRequest, TaskServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceGetRequest, TaskServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Create(c1.api.task.v1.TaskServiceCreateRequest) returns (c1.api.task.v1.TaskServiceGetResponse);
     */
    create(input: TaskServiceCreateRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateRequest, TaskServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceCreateRequest, TaskServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a revoke task
     *
     * @generated from protobuf rpc: CreateRevokeTask(c1.api.task.v1.TaskServiceCreateRevokeRequest) returns (c1.api.task.v1.TaskServiceCreateRevokeResponse);
     */
    createRevokeTask(input: TaskServiceCreateRevokeRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateRevokeRequest, TaskServiceCreateRevokeResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceCreateRevokeRequest, TaskServiceCreateRevokeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a grant task
     *
     * @generated from protobuf rpc: CreateGrantTask(c1.api.task.v1.TaskServiceCreateGrantRequest) returns (c1.api.task.v1.TaskServiceCreateGrantResponse);
     */
    createGrantTask(input: TaskServiceCreateGrantRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateGrantRequest, TaskServiceCreateGrantResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceCreateGrantRequest, TaskServiceCreateGrantResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a grant task
     *
     * @generated from protobuf rpc: CreateManyGrantTasks(c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest) returns (c1.api.task.v1.TaskServiceListResponse);
     */
    createManyGrantTasks(input: TaskServiceCreateManyGrantTasksRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateManyGrantTasksRequest, TaskServiceListResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceCreateManyGrantTasksRequest, TaskServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOffboardingTask(c1.api.task.v1.TaskServiceCreateOffboardingRequest) returns (c1.api.task.v1.TaskServiceCreateOffboardingResponse);
     */
    createOffboardingTask(input: TaskServiceCreateOffboardingRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateOffboardingRequest, TaskServiceCreateOffboardingResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceCreateOffboardingRequest, TaskServiceCreateOffboardingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateActionTask(c1.api.task.v1.TaskServiceCreateActionRequest) returns (c1.api.task.v1.TaskServiceCreateActionResponse);
     */
    createActionTask(input: TaskServiceCreateActionRequest, options?: RpcOptions): UnaryCall<TaskServiceCreateActionRequest, TaskServiceCreateActionResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceCreateActionRequest, TaskServiceCreateActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * TODO(pquerna): validate use case - maybe remove?
     *
     * @generated from protobuf rpc: Update(c1.api.task.v1.TaskServiceUpdateRequest) returns (c1.api.task.v1.TaskServiceGetResponse);
     */
    update(input: TaskServiceUpdateRequest, options?: RpcOptions): UnaryCall<TaskServiceUpdateRequest, TaskServiceGetResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceUpdateRequest, TaskServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List(c1.api.task.v1.TaskServiceListRequest) returns (c1.api.task.v1.TaskServiceListResponse);
     */
    list(input: TaskServiceListRequest, options?: RpcOptions): UnaryCall<TaskServiceListRequest, TaskServiceListResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceListRequest, TaskServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete(c1.api.task.v1.TaskServiceDeleteRequest) returns (c1.api.task.v1.TaskServiceDeleteResponse);
     */
    delete(input: TaskServiceDeleteRequest, options?: RpcOptions): UnaryCall<TaskServiceDeleteRequest, TaskServiceDeleteResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceDeleteRequest, TaskServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * View specific
     *
     * @generated from protobuf rpc: GetSendReminderPreview(c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest) returns (c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse);
     */
    getSendReminderPreview(input: TaskServiceGetSendReminderPreviewRequest, options?: RpcOptions): UnaryCall<TaskServiceGetSendReminderPreviewRequest, TaskServiceGetSendReminderPreviewResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceGetSendReminderPreviewRequest, TaskServiceGetSendReminderPreviewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendReminder(c1.api.task.v1.TaskServiceSendReminderRequest) returns (c1.api.task.v1.TaskServiceSendReminderResponse);
     */
    sendReminder(input: TaskServiceSendReminderRequest, options?: RpcOptions): UnaryCall<TaskServiceSendReminderRequest, TaskServiceSendReminderResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskServiceSendReminderRequest, TaskServiceSendReminderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get resolved form data by task ID
     *
     * @generated from protobuf rpc: GetByTaskId(c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest) returns (c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse);
     */
    getByTaskId(input: ResolvedFormDataServiceGetByTaskIdRequest, options?: RpcOptions): UnaryCall<ResolvedFormDataServiceGetByTaskIdRequest, ResolvedFormDataServiceGetByTaskIdResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResolvedFormDataServiceGetByTaskIdRequest, ResolvedFormDataServiceGetByTaskIdResponse>("unary", this._transport, method, opt, input);
    }
}
